import React, { useRef, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

import "./SafetyHeroBanner.css";

const SafetyHeroBanner = () => {
    let videoRef = useRef(null);
    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.play();
        }
    }, [videoRef]);
    const data = useStaticQuery(graphql`
        query SafetyHeroBannerQuery {
            mobileImage: file(relativePath: { eq: "safety-mobile.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }
        }
    `);

    const sources = [
        {
            ...data.mobileImage.childImageSharp.fluid,
            media: `(max-width: 600px)`,
        },
    ];
    return (
        <div className="safety-hp">
            <div className="safety-hp__container">
                <div className="safety-hp__container__video">
                    <video
                        autoPlay
                        preload="auto"
                        muted
                        ref={videoRef}
                        disableRemotePlayback
                        playsInline
                    >
                        <source
                            src="https://website.phonepe.com/assets/page/safety-herobanner.mp4"
                            type="video/mp4"
                        />
                    </video>
                </div>
                <Img
                    fluid={sources}
                    alt=""
                    imgStyle={{
                        height: "100%",
                        width: "100%",
                        objectFit: "cover",
                    }}
                    className="safety-hp__container__image"
                />
            </div>
        </div>
    );
};

export default SafetyHeroBanner;
